import dayjs from "dayjs";
import * as XLSX from "xlsx";

import { supabase } from "~/integrations/supabase/client";

interface ProductRow {
  sku: string | null;
  short_name: string;
  long_name: string | null;
  stock: number | null;
  base_measurement_unit: string | null;
  group_description: string | null;
}

/**
 * Export the "Consulta de Stock" finished-goods list to an Excel file.
 * One row per product using the live products.stock balance (source of truth
 * since the WMS position workflow was retired), ordered by stock descending.
 */
export const exportStockConsultationToExcel = async (): Promise<void> => {
  const { data, error } = await supabase
    .from("products")
    .select(
      "sku, short_name, long_name, stock, base_measurement_unit, group_description"
    )
    .is("deleted_at", null)
    .order("stock", { ascending: false, nullsFirst: false });
  if (error) throw error;

  const rows = (data ?? []) as ProductRow[];

  const excelData = rows.map((p) => ({
    SKU: p.sku,
    Producto: p.long_name || p.short_name,
    Grupo: p.group_description,
    Unidad: p.base_measurement_unit,
    Stock: p.stock ?? 0,
  }));

  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(excelData);

  // Set column widths: SKU, Producto, Grupo, Unidad, Stock.
  worksheet["!cols"] = [
    { wch: 15 }, // SKU
    { wch: 40 }, // Producto
    { wch: 18 }, // Grupo
    { wch: 10 }, // Unidad
    { wch: 12 }, // Stock
  ];

  XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Productos");
  XLSX.writeFile(
    workbook,
    `consulta_stock_${dayjs().format("YYYY-MM-DD")}.xlsx`
  );
};
